const LanguageList = () => {
  return (
    <>
      <div className=" justify-content-start align-items-center mb-3">
        <div className=" lh-base border-radius-2xl col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">हिन्दी</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Hindi</b>
              </div>
            </div>
          </a>
        </div>
        <div className=" lh-base col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">தமிழ்</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Tamil</b>
              </div>
            </div>
          </a>
        </div>
        <div className=" lh-base col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">తెలుగు</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Telugu</b>
              </div>
            </div>
          </a>
        </div>
        <div className=" lh-base col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">ಕನ್ನಡ</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Kanada</b>
              </div>
            </div>
          </a>
        </div>
        <div className=" lh-base col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">മലയാളം</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Malayalam</b>
              </div>
            </div>
          </a>
        </div>
        <div className=" lh-base col language p-2">
          <a href=".">
            <div className=" ms-3">
              <b className=" fw-normal text-black text-md">मराठी</b>
              <div>
                <b className=" fw-normal text-black-50 text-sm">Marati</b>
              </div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default LanguageList;
